import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import withSDK from '../../../core/hocs/withSDK';
import useUserFilters from '../../../core/hooks/useUserFilters';
import customizableComponent from '../../../core/hocs/customization';
import Select from '../../../core/components/Select';
import useCategories from '../../../social/hooks/useCategories';
import CategoryHeader from '../../../social/components/category/Header';
import { Selector, SelectIcon, InputPlaceholder } from './styles';
import userMatchesCommunityCategorySegment from '../../../helpers/userMatchesCommunityCategorySegment';
const CategorySelector = ({ 'data-qa-anchor': dataQaAnchor = '', value: categoryId, onChange, parentContainer = null, currentUserId, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const close = () => setIsOpen(false);
    const userFilters = useUserFilters(currentUserId);
    const [categories] = useCategories({ isDeleted: false });
    const options = categories
        .filter((cat) => userMatchesCommunityCategorySegment(userFilters, cat))
        .map((category) => ({
        name: category.name,
        value: category.categoryId,
    }));
    const itemRenderer = ({ value }) => React.createElement(CategoryHeader, { categoryId: value });
    const triggerRenderer = (props) => {
        return (React.createElement(Selector, Object.assign({}, props, { "data-qa-anchor": `${dataQaAnchor}-category-selector` }),
            categoryId ? (React.createElement(CategoryHeader, { categoryId: categoryId })) : (React.createElement(FormattedMessage, { id: "selectACategory" }, (placeholder) => React.createElement(InputPlaceholder, null, placeholder))),
            React.createElement(SelectIcon, null)));
    };
    return (React.createElement(Select, { "data-qa-anchor": `${dataQaAnchor}-category`, options: options, renderTrigger: (props) => triggerRenderer(Object.assign(Object.assign({}, props), { onClick: toggle })), renderItem: itemRenderer, parentContainer: parentContainer, isOpen: isOpen, handleClose: close, onSelect: ({ value }) => onChange(value) }));
};
CategorySelector.propTypes = {
    'data-qa-anchor': PropTypes.string,
    value: PropTypes.string,
    parentContainer: PropTypes.instanceOf(Element),
    onChange: PropTypes.func,
    currentUserId: PropTypes.string.isRequired,
};
export default withSDK(customizableComponent('CategorySelector', CategorySelector));
//# sourceMappingURL=CategorySelector.js.map